import React from "react";
import CheckIcon from "./check-icon";

interface CheckBoxFieldProps {
  label: string;
  checked: boolean;
  isBeta: boolean;
  onChange: (checked: boolean) => void;
  onHelpClick?: () => void;
}

const CheckBoxField = ({
  label,
  checked,
  onChange,
  isBeta,
  onHelpClick,
}: CheckBoxFieldProps) => {
  return (
    <div
      className={`${
        !checked ? "text-[#2B2B2B]" : ""
      } relative text-[24px] text-center pb-[10px]`}
    >
      <div
        className="absolute left-0 top-[7px] w-[24px] h-[24px] cursor-pointer  bg-[#3B3B3B]"
        onClick={() => onChange(!checked)}
      >
        {checked && (
          <CheckIcon
            className="absolute left-[0px] top-[-7px] w-[40px] h-[28px]"
            color={checked ? "#FF0000" : "#2B2B2B"}
          />
        )}
      </div>
      <span>{label}</span>

      {isBeta && (
        <div className="absolute left-[50%] translate-x-[calc(-50%+70px)] top-[-25px]">
          <span className="text-[#FE0000] text-[11px]">BETA</span>
        </div>
      )}

      <div
        className="absolute right-0 top-0 hover:cursor-pointer"
        onClick={onHelpClick}
      >
        <span className="text-[#0099FE]">?</span>
      </div>
    </div>
  );
};

export default CheckBoxField;
